import { render, staticRenderFns } from "./VpsPlan.vue?vue&type=template&id=7ac1d785&"
import script from "./VpsPlan.vue?vue&type=script&lang=js&"
export * from "./VpsPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports